import React, { useRef, useEffect } from 'react';

import st from './index.module.scss';

import Head from 'next/head';

import { SeoPlanRequestForm, WhatHappensNext } from '../../../components/seo';
import { AppearencesInMedia, BusinessInNumbers, ReviewsOn } from '../../../components/seo/sections';

const SeoForm = props => {
  const sideBar = useRef(null);
  useEffect(() => {
    document.body.classList.remove('overflow-x-hidden');
    if (sideBar.current) {
      const div = sideBar.current;

      div.style.height = div.scrollHeight + 'px';
    }
  }, []);

  return (
    <>
      <Head>
        <title>SEO Services Request Form - Get a Proposal | Prodigi</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/seo/seo-form" />
        <meta
          name="description"
          content="Request a customized SEO plan from Prodigi. Share your business goals, and our experts will craft a customized strategy to improve your online presence."
        />
        <meta property="og:url" content="https://weprodigi.com/seo/seo-form" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="SEO Services Request Form - Get a Proposal | Prodigi" />
        <meta
          property="og:description"
          content="Request a customized SEO plan from Prodigi. Share your business goals, and our experts will craft a customized strategy to improve your online presence."
        />
      </Head>
      <div className="grid grid-cols-1 md:grid-cols-2">
        <div className="bg-[#EEEAF9] px-[30px] py-[48px]">
          <div className="flex flex-col ml-auto max-w-[520px] gap-[48px]">
            <h1 className="text-[32px] md:text-[34px] font-[600] md:leading-[72px] leading-[39px]">SEO Plan Request Form</h1>
            <div className="w-full flex justify-end">
              <SeoPlanRequestForm country={props.country} />
            </div>
          </div>
        </div>
        <div className="bg-white px-[30px] py-[48px] relative z-[1]">
          <div ref={sideBar} className={`hidden md:flex flex-col absolute ${st['stickyBar']}`}>
            <div className={`flex flex-col max-w-[520px] gap-[48px] items`}>
              <h2 className="flex justify-center text-[34px] font-[600] md:leading-[72px] leading-[41px] text-[#09AF77]">What Happens Next? </h2>
              <div className="grid grid-cols-12 gap-[10px] relative pl-[30px]">
                <img className="absolute top-[-36px]" src="/images/seo/here.png" alt="here" />
                <div className="blob w-full "></div>
                <div className="col-span-11 py-[10px]">
                  <WhatHappensNext />
                </div>
              </div>
            </div>
          </div>

          <div className={`md:hidden flex flex-col`}>
            <div className="flex flex-col max-w-[520px] gap-[48px] items">
              <h2 className="flex justify-center text-[34px] font-[600] md:leading-[72px] leading-[41px] text-[#09AF77]">What Happens Next? </h2>
              <div className="grid md:grid-cols-12 grid-cols-10 gap-[10px] relative ">
                <img className="absolute top-[-36px] md:w-[96px] w-[72px]" src="/images/seo/here.png" alt="here" />
                <div className="blob w-full "></div>
                <div className="md:col-span-11 col-span-9 py-[10px]">
                  <WhatHappensNext />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ReviewsOn />
      <BusinessInNumbers color="#0052B4" />
      <AppearencesInMedia />
    </>
  );
};

export default SeoForm;
